import {
  collectEditedFieldPaths,
  DrawerEntityKind,
  hasEntityChanges,
} from './LoanEditorCustomFormDrawer.utils';

export const buildEntityChangeState = ({
  formPendingChanges,
  fieldPathsByEntity,
  isPostClosingEditable,
  isClosingEditable,
  isFundingEditable,
}) => {
  const checkHasEntityChanges = entityKind =>
    hasEntityChanges({ formPendingChanges, fieldPaths: fieldPathsByEntity[entityKind] });
  const loanAndLockEditedFieldPaths = collectEditedFieldPaths({
    formPendingChanges,
    fieldPaths: fieldPathsByEntity[DrawerEntityKind.LOAN_AND_LOCK],
  });

  return {
    loanAndLockEditedFieldPaths,
    hasLoanAndLockChanges: !!loanAndLockEditedFieldPaths.size,
    hasPropertyInfoChanges: checkHasEntityChanges(DrawerEntityKind.PROPERTY_INFO),
    hasBorrowerChanges: checkHasEntityChanges(DrawerEntityKind.BORROWER),
    hasContactChanges: checkHasEntityChanges(DrawerEntityKind.CONTACT),
    hasPostClosingChanges:
      isPostClosingEditable && checkHasEntityChanges(DrawerEntityKind.POST_CLOSING),
    hasClosingChanges: isClosingEditable && checkHasEntityChanges(DrawerEntityKind.CLOSING),
    hasFundingChanges: isFundingEditable && checkHasEntityChanges(DrawerEntityKind.FUNDING),
  };
};

const checkAnySection = ({ sectionResolutions, flag }) =>
  sectionResolutions.some(sectionResolution => !!sectionResolution[flag]);

export const summarizeSectionRequirements = sectionResolutions => ({
  requiresBorrowerSelection: checkAnySection({
    sectionResolutions,
    flag: 'requiresBorrowerSelection',
  }),
  requiresContactSelection: checkAnySection({
    sectionResolutions,
    flag: 'requiresContactSelection',
  }),
  requiresClosingCompanySelection: checkAnySection({
    sectionResolutions,
    flag: 'requiresClosingCompanySelection',
  }),
  hasBorrowerFields: checkAnySection({ sectionResolutions, flag: 'hasBorrowerFields' }),
  hasContactFields: checkAnySection({ sectionResolutions, flag: 'hasContactFields' }),
  hasClosingCompanyFields: checkAnySection({ sectionResolutions, flag: 'hasClosingCompanyFields' }),
});
